import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FormBuilder from 'components/forms/FormBuilder/FormBuilder';
import { postRequestPasswordReset } from 'server/api';
import getAccessToken from 'selectors/getAccessToken';
import createGetUrl from 'utils/createGetUrl';

const getFields = createSelector(
  getAccessToken,
  token => (
    // If we have an auth token,
    // skip the email field (and use the auth token)
    token
      ? []
      : [{
        type: 'email',
        name: 'email',
        label: 'Email',
        required: true,
      }]),
);


// Pass in the query/type so we can preserve this info across page links
const mapStateToProps = state => ({
  hideOnSubmit: true,
  submitLabel: 'Send reset email',
  actionAlt: {
    title: 'Return to login',
    to: { type: 'LOGIN' },
  },
  successMessage: 'If the email address is registered, a reset email has been sent.',
  fields: getFields(state),
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(postRequestPasswordReset(data)),
});

const SiteForgotPasswordForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormBuilder);

export default SiteForgotPasswordForm;
